import { useQuery } from '@tanstack/react-query';
import api from './api';

/**
 * Page /rapports — agrégats côté serveur (évite useAllCommandes + useAllPaiements + useAllDepenses).
 * Les hooks et URLs sont dédiés ; ne pas renommer sans mettre à jour les composants Rapports.
 */

export const useRapportDay = (dateStr) =>
  useQuery({
    queryKey: ['rapport', 'day', dateStr],
    queryFn: () =>
      api
        .get('/rapport/day', { params: { date: dateStr } })
        .then((res) => res.data),
    enabled: Boolean(dateStr),
    staleTime: 1000 * 30,
  });

/**
 * startDate / endDate : YYYY-MM-DD ; si l’un manque, le backend agrège tout l’historique
 * (équivalent à l’ancien isBetweenDates qui retournait true sans plage).
 */
export const useRapportRange = (startDate, endDate) => {
  const both = Boolean(startDate && endDate);
  return useQuery({
    queryKey: ['rapport', 'range', startDate ?? '', endDate ?? ''],
    queryFn: () =>
      api
        .get('/rapport/range', {
          params: {
            startDate: both ? startDate : undefined,
            endDate: both ? endDate : undefined,
          },
        })
        .then((res) => res.data),
    staleTime: 1000 * 30,
  });
};

/** month : 0–11 (toutes les années), comme le select « Rapports Mensuel ». */
export const useRapportMonth = (month) =>
  useQuery({
    queryKey: ['rapport', 'month', month],
    queryFn: () =>
      api.get('/rapport/month', { params: { month } }).then((res) => res.data),
    staleTime: 1000 * 30,
  });

/** Séries 12 mois pour les deux graphiques Bar (commandes/paiements + entrée/sortie). */
export const useRapportChartSeries = () =>
  useQuery({
    queryKey: ['rapport', 'chart-series'],
    queryFn: () => api.get('/rapport/chart-series').then((res) => res.data),
    staleTime: 1000 * 60,
  });
